import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldSelectComponent } from './form-field-select.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    FormFieldSelectComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule
  ],
  exports: [ FormFieldSelectComponent ]
})
export class FormFieldSelectModule { }
